<template>
  <div class="flex justify-between xl:space-x-3 items-center">
    <!-- <language-select /> -->
    <div
      @click="toggleDarkMode()"
      @keyup="toggleDarkMode()"
      class="flex space-x-1"
    >
      <SunIcon class="icon dark:text-gray-300 text-yellow-500 hover:cursor-pointer stroke-1" />
      <MoonIcon class="icon text-gray-300 dark:text-white hover:cursor-pointer stroke-1" />
    </div>
    <button
      @click="doAction()"
    >
      <ArrowRightStartOnRectangleIcon v-if="authenticated" class="w-5 h-5 stroke-1" />
      <log-in-icon v-else class="w-4 h-4" />
    </button>
    <router-link to="/profile" v-if="!isSuperAdmin" class="link">
      <UserIcon class="w-5 h-5 stroke-1" />
    </router-link>
    <router-link to="/cart" v-if="!isSuperAdmin" class="link">
      <div class="relative flex items-center cursor-pointer">
        <p class="rounded-full w-2 h-2 flex justify-center bg-lh_gray text-white text-xs bottom-1 left-2
        absolute z-20 items-center font-sans-serif font-bold p-3" v-if="productsCount > 0">
          {{ productsCount }}
        </p>
        <ShoppingBagIcon class="w-5 h-5 stroke-1" />
      </div>
    </router-link>
    <router-link to="/backoffice/cart" v-if="isSuperAdmin">
      <div class="relative flex items-center cursor-pointer">
        <p class="rounded-full w-2 h-2 flex justify-center bg-lh_gray text-white text-xs bottom-1 left-2
        absolute z-20 items-center font-sans-serif font-bold p-3" v-if="productsCount > 0">
          {{ productsCount }}
        </p>
        <ShoppingBagIcon class="w-5 h-5 stroke-1" />
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LogInIcon from '@/components/graphic/LogInIcon.vue';
import {
  MoonIcon,
  SunIcon,
  ArrowRightStartOnRectangleIcon,
  UserIcon,
  ShoppingBagIcon,
} from '@heroicons/vue/24/outline';
// import LanguageSelect from '@/components/base/LanguageSelect.vue';

export default {
  components: {
    ShoppingBagIcon,
    LogInIcon,
    ArrowRightStartOnRectangleIcon,
    MoonIcon,
    SunIcon,
    // LanguageSelect,
    UserIcon,
  },
  data() {
    return {
      lsTheme: '',
    };
  },
  created() {
    this.startColorMode();
  },
  computed: {
    ...mapGetters('auth', ['authenticated', 'isSuperAdmin']),
    ...mapGetters('cart', ['productsCount']),
  },
  methods: {
    ...mapActions('auth', ['signOut']),
    async doAction() {
      if (!this.authenticated) {
        this.$router.push('/sign-in');
        return;
      }
      await this.signOut();
      this.$router.push('/');
    },
    startColorMode() {
      this.lsTheme = localStorage.getItem('theme');
      this.setColorMode(this.lsTheme);
    },
    toggleDarkMode() {
      this.lsTheme = localStorage.getItem('theme') === 'dark' ? 'light' : 'dark';
      this.setColorMode(this.lsTheme);
    },
    setColorMode(lsTheme) {
      const element = document.body;
      element.removeAttribute('class');
      element.classList.add(lsTheme);
      localStorage.setItem('theme', lsTheme);
    },
  },
};
</script>

<style scoped>
  .icon {
    @apply w-5 h-5 z-50 duration-500;
  }
  .link.router-link-active {
    @apply fill-lh_red border-lh_red
  }
  .link {
    @apply fill-gray-400 dark:fill-gray-200 border-gray-300
  }
  .backoffice.link.router-link-active {
    @apply fill-lh_gold border-lh_gold
  }
</style>
